import {
  MATIC_DECIMAL_PART,
  USD_DECIMAL_PART,
} from "@validation/lengthConstants";

/**
 * Convert MATIC-USD
 * @param {number} amount in MATIC
 * @param {number} rate
 * @returns
 */
export const convertMaticToUsd = (amount = 0, rate) =>
  (amount * rate).toFixed(USD_DECIMAL_PART);

/**
 * Convert USD-MATIC
 * @param {number} amount in USD
 * @param {number} rate
 * @returns
 */
export const convertUsdToMatic = (amount, rate) =>
  (amount / rate).toFixed(MATIC_DECIMAL_PART);

/**
 * Formats input to `dd.dd` format
 * @param {number} value
 * @returns
 */
export const moneyPipe =
  (maxDigits = MATIC_DECIMAL_PART) =>
  (value) => {
    if (!value) {
      return "";
    }

    const [int, ...float] = value
      ?.toString()
      ?.replace(/[^\d.]/g, "")
      ?.split(".");

    if (!int) {
      return "";
    }

    const floatPart = float.join("").replace(/\./g, "");

    return `${int}${float.length ? "." : ".00"}${floatPart.slice(
      0,
      maxDigits,
    )}`;
  };

/**
 * Convert price to cents
 * @param {string} price in USD
 */
export const toCents = (price) => Math.round(price * 100);

/**
 * Convert price from cents to dollar
 * @param {string} price in cents
 */
export const toDollar = (price) => +(price / 100).toFixed(2);
